const state = () => {
  return {
    menu: [
      {
        icon: 'HomeIcon',
        pageName: 'admin-employees-home',
        title: 'reservation.list'
      },
      {
        icon: 'CalendarIcon',
        pageName: 'admin-employees-plan',
        title: 'employee.plan'
      },
      {
        icon: 'CrosshairIcon',
        pageName: 'admin-employees-customers',
        title: 'customer.list'
      }
    ]
  }
}

// getters
const getters = {
  menu: state => state.menu
}

// actions
const actions = {}

// mutations
const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
